import { isRequestAborted } from './isRequestAborted'

/**
 * True when the request never got an HTTP response (offline, DNS, timeout, CORS).
 * Axios reports that as a request with no response, which does not depend on locale.
 * Message matching only covers non-Axios failures and is locale-sensitive.
 * navigator.onLine is not consulted: on mobile it often stays true without internet.
 */
export function isConnectivityError(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false
  if (isRequestAborted(error)) return false

  const err = error as {
    code?: string
    response?: unknown
    request?: unknown
    message?: string
  }
  if (err.response) return false

  if (
    err.code === 'ERR_NETWORK'
    || err.code === 'ECONNABORTED'
    || err.code === 'ERR_INTERNET_DISCONNECTED'
  ) {
    return true
  }

  if (err.request) return true

  const message = String(err.message || '')
  return /network error/i.test(message)
    || /timeout of \d+ms exceeded/i.test(message)
    || /origen cruzado|failed to fetch|networkerror/i.test(message)
}
